export default {
      id: "logo-vpn-usage",
      viewBox: "0 0 230 48",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#logo-vpn",
      toString: function () {
        return this.url;
      }
    }